<p-panel *ngIf="this.splittedCommands !== undefined && this.splittedCommands.length>0">
	<ng-template pTemplate="header">
		<div class="flex align-items-center">
			<span class="font-semibold">{{ 'COMMANDS' | translate }}</span>
		</div>
	</ng-template>
	<ng-template pTemplate="content">
		<div class="grid">
			<div
				class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-noround-top border-round-bottom-xl"
				*ngIf="!deviceConfiguredOnline()">
				<p-tag icon="pi cm-alert" [value]="('COMMANDS_NOT_AVAILABLE' | translate)" severity="warning"></p-tag>
			</div>
			<div class="col-12" *ngFor="let commands of splittedCommands; let i = index">
				<p-panel styleClass="p-panel-whitebg">
					<ng-template pTemplate="header">
						<div class="flex align-items-center">
							<span class="font-semibold">{{ 'OUT ' + commands[0].OutputId }}</span>
						</div>
					</ng-template>
					<div class="grid">
						<div class="col-12 flex align-items-center justify-content-center pb-0"
							*ngFor="let command of commands">
							<button type="button" pButton pRipple id="buttonDeviceCommand-{{command.Description}}"
								[disabled]="!deviceConfiguredOnline()" label="{{ command.Description }}"
								class="p-button-primary text-xl font-normal w-20rem" (click)="executeCommand(command.Id)">
							</button>
						</div>
					</div>
				</p-panel>
			</div>
		</div>
	</ng-template>
</p-panel>